/**
 * Locales that keyword lists exist in: `keywords` for `en`, `keywords_<lang>` for the rest.
 */
export const KEYWORD_LANGS = [
  "en",
  "ru",
  "zh",
  "ja",
  "hi",
  "es",
  "fr",
  "de",
  "pl",
  "pt",
  "id",
] as const;

export type KeywordLang = (typeof KEYWORD_LANGS)[number];

export function keywordsField(lang: KeywordLang): "keywords" | `keywords_${KeywordLang}` {
  return lang === "en" ? "keywords" : `keywords_${lang}`;
}
